import { render } from "./OrdersShareFilesView.vue?vue&type=template&id=d9fa7b56&scoped=true"
import script from "./OrdersShareFilesView.vue?vue&type=script&lang=js"
export * from "./OrdersShareFilesView.vue?vue&type=script&lang=js"

import "./OrdersShareFilesView.vue?vue&type=style&index=0&id=d9fa7b56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9fa7b56"]])

export default __exports__